import * as React from "react";
import { MenuItem, Select, Typography } from "@mui/material";
import { useContext } from "react";
import { ProductRepositoryContext } from "../context/ProductRepositoryState";
import { PRODUCT_REPOSITORY_TYPE } from "../context/ActionType";
import { getUniqueCategory } from "../service/productService";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";

const SearchController = () => {
  const { t } = useTranslation();
  const { dispatch } = useContext(ProductRepositoryContext);
  const [category, setCategory] = React.useState("");

  const categories = getUniqueCategory();

  const handleSelectCategory = async (event) => {
    const value = event.target.value;

    setCategory(value);
    dispatch({ type: PRODUCT_REPOSITORY_TYPE.UPDATE_CATEGORY, payload: value });
  };

  return (
    <>
      <Stack direction="row" alignItems="center" m={1}>
        <Typography sx={{ minWidth: "100px" }}>{t("category")}</Typography>
        <Select
          value={category}
          onChange={handleSelectCategory}
          sx={{ minWidth: "200px" }}
          displayEmpty={true}
        >
          <MenuItem value={""}>All</MenuItem>
          {categories.map((item, index) => (
            <MenuItem value={item} key={index}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </Stack>
    </>
  );
};

export default SearchController;
